module.exports = {
          srcSet: __webpack_public_path__ + "85ba6a3411753f6640773138c7a7091e-1920.png"+" 1920w",
          images:[ {path: __webpack_public_path__ + "85ba6a3411753f6640773138c7a7091e-1920.png",width: 1920,height: 594}],
          src: __webpack_public_path__ + "85ba6a3411753f6640773138c7a7091e-1920.png",
          toString:function(){return __webpack_public_path__ + "85ba6a3411753f6640773138c7a7091e-1920.png"},
          
          width: 1920,
          height: 594
        }